import React, { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import logo from "../../static/ODNRewers_sm.png";
import logoBB from "../../static/BB_logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { faCartShopping, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavbarOferta } from "./NavbarOferta";
import { NavbarUser } from "./NavbarUser";
import AnimationSideButton from "../elements/AnimationSideButton";

const Navigation = () => {
    const [isHamburgerActive, setIsHamburgerActive] = React.useState(false);
    const { basketCnt, inquiryCnt } = useContext(UserContext);
    const navigation = useNavigate();
    const location = useLocation();

    let categoryId = "";
    if (location.pathname.includes("/list/")) {
        categoryId = location.pathname.substring(location.pathname.length - 1);
    }

    return (
        <>
            {inquiryCnt > 0 && location.pathname.includes("zapytanie") === false && location.pathname.includes("kontakt") === false && (
                <AnimationSideButton to={"/zapytanie/" + categoryId} />
                // <div className="fix-bottom-button">
                //     <Link to={"/zapytanie/" + categoryId} className="has-text-white">
                //         Twoje zapytanie
                //     </Link>
                // </div>
            )}

            <nav className="navbar" role="navigation" aria-label="main navigation">
                <div className="navbar-brand">
                    <div className="navbar-item is-clickable" onClick={() => navigation("/")}>
                        <a href="https://odnrewers.pl">
                            <img src={logo} alt="ODN Rewers" />
                        </a>
                    </div>
                    <div className="navbar-item is-clickable" onClick={() => navigation("/")}>
                        <a href="https://biegbelfrow.pl">
                            <img src={logoBB} alt="Bieg Belfrów" />
                        </a>
                    </div>

                    {/* <Link to="/koszyk" reloadDocument className="navbar-item navbar-burger burger">
                <FontAwesomeIcon icon={faCartShopping} />{basketCnt}
                </Link> */}

                    <div
                        onClick={() => {
                            setIsHamburgerActive(!isHamburgerActive);
                        }}
                        role="button"
                        className={`navbar-burger burger ${isHamburgerActive ? "is-active" : ""}`}
                        aria-label="menu"
                        aria-expanded="false"
                        data-target="navbarMainMenu"
                    >
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </div>
                </div>

                <div id="navbarMainMenu" className={`navbar-menu ${isHamburgerActive ? " is-active" : ""}`}>
                    <div className="navbar-start">
                        {isHamburgerActive ? (
                            <NavbarOferta />
                        ) : (
                            <div className="navbar-item has-dropdown is-hoverable">
                                <a
                                    className="navbar-link"
                                    onClick={() => {
                                        if (isHamburgerActive) setIsHamburgerActive(!isHamburgerActive);
                                    }}
                                >
                                    Oferta szkoleń
                                </a>

                                <div className="navbar-dropdown is-active">
                                    <NavbarOferta />
                                </div>
                            </div>
                        )}

                        <Link to="/kontakt" reloadDocument className="navbar-item">
                            Kontakt
                        </Link>
                    </div>

                    <div className="navbar-end">
                        {/* <div className="navbar-item">
                         <FontAwesomeIcon icon={faUser} />
                         </div> */}
                        {basketCnt > 0 && (
                            <>
                                <Link to="/koszyk" reloadDocument title="koszyk">
                                    <a className="button px-2 py-1">
                                        <FontAwesomeIcon icon={faCartShopping} />
                                        &nbsp;{basketCnt}
                                    </a>
                                </Link>
                                {/* <Link to="/koszyk" reloadDocument className="navbar-item">Koszyk: {basketCnt}</Link>    */}
                            </>
                        )}
                        <NavbarUser />
                        {/* {isHamburgerActive ? (
                            <>
                                <hr className="my-0" />
                                <NavbarUser />
                            </>
                        ) : (
                            <div className="navbar-item has-dropdown is-hoverable">
                                <div className="navbar-item has-dropdown is-hoverable">
                                    <a className="navbar-link">
                                        {isLogged === true ? (
                                            <span>{userName ? userName : <FontAwesomeIcon icon={faUser} />}</span>
                                        ) : (
                                            <span>Moje konto</span>
                                        )}
                                    </a>

                                    <div className="navbar-dropdown">
                                        {" "}
                                        <NavbarUser />{" "}
                                    </div>
                                </div>
                            </div>
                        )} */}
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navigation;
